"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[56494],{

/***/ 16543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var DefaultCurrencyFormat = function(_param) {
    var value = _param.value, Symbol = _param.Symbol, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "value",
        "Symbol"
    ]);
    var obj = {
        "\u20BA": "TRY",
        $: "USD",
        "\u20AC": "EUR",
        "\xa3": "GBP"
    };
    var formattedValue = new Intl.NumberFormat( true ? "en-GB" : 0, {
        style: "currency",
        currency: obj[Symbol],
        minimumFractionDigits: 0
    }).format(value);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: formattedValue
    });
//return <></>;
//if (Symbol == "₺")
//  return (
//    <CurrencyFormat
//      value={value}
//      displayType={"text"}
//      thousandSeparator={"."}
//      decimalSeparator={","}
//      suffix={Symbol}
//      {...props}
//      renderText={(value) => <>{value}</>}
//    />
//  );
//return (
//  <CurrencyFormat
//    value={value}
//    displayType={"text"}
//    thousandSeparator={"."}
//    decimalSeparator={","}
//    prefix={Symbol}
//    {...props}
//    renderText={(value) => <>{value}</>}
//  />
//);
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultCurrencyFormat);


/***/ }),

/***/ 80103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _icons_Ktb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9842);



var PlayButtonIcon = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "23px",
        height: "23px",
        viewBox: "0 0 23 23",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "play-button",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11.5 0C5.15851 0 0 5.15901 0 11.5C0 17.841 5.15851 23 11.5 23C17.8415 23 23 17.841 23 11.5C23 5.15901 17.8415 0 11.5 0ZM16.0717 11.9029L9.36343 16.2154C9.28481 16.2664 9.19403 16.2917 9.10418 16.2917C9.02557 16.2917 8.94601 16.272 8.8749 16.2332C8.72046 16.149 8.625 15.988 8.625 15.8125L8.625 7.1875C8.625 7.01204 8.72046 6.85104 8.8749 6.76681C9.02651 6.68352 9.21649 6.68864 9.36343 6.7846L16.0717 11.0971C16.2084 11.1851 16.2917 11.3372 16.2917 11.5C16.2917 11.6628 16.2084 11.8149 16.0717 11.9029Z",
                id: "Shape",
                fill: "currentColor",
                stroke: "none"
            })
        })
    });
};
var HeartIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "21px",
        height: "19px",
        viewBox: "0 0 21 19",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "heart-copy-btn",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.8553 1.78312C17.7952 0.633281 16.3405 0 14.7589 0C13.5767 0 12.4941 0.37375 11.5409 1.11078C11.06 1.48281 10.6242 1.93797 10.24 2.46922C9.85594 1.93813 9.42 1.48281 8.93891 1.11078C7.98594 0.37375 6.90328 0 5.72109 0C4.13953 0 2.68469 0.633281 1.62453 1.78312C0.577031 2.91953 2.27374e-15 4.47203 2.27374e-15 6.15484C2.27374e-15 7.88688 0.645469 9.47234 2.03125 11.1445C3.27094 12.6403 5.05266 14.1587 7.11594 15.917C7.82047 16.5175 8.61906 17.1981 9.44828 17.9231C9.66734 18.115 9.94844 18.2206 10.24 18.2206C10.5314 18.2206 10.8127 18.115 11.0314 17.9234C11.8606 17.1983 12.6597 16.5173 13.3645 15.9166C15.4275 14.1586 17.2092 12.6403 18.4489 11.1444C19.8347 9.47234 20.48 7.88688 20.48 6.15469C20.48 4.47203 19.903 2.91953 18.8553 1.78312Z",
                id: "Path",
                fill: "currentColor",
                stroke: "none"
            })
        })
    });
};
var DetailPoolIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "35px",
        height: "35px",
        viewBox: "0 0 35.0 35.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "110111110551154911310611952",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "455356571161135712011399",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1916,0 C1918.76142,-5.07265313e-16 1921,2.23857625 1921,5 L1921,430 C1921,432.761424 1918.76142,435 1916,435 L5,435 C2.23857625,435 2.69835295e-14,432.761424 0,430 L0,5 C-3.38176876e-16,2.23857625 2.23857625,-5.70998362e-15 5,0 L1916,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "9810411012112099561095397",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M271,0 C274.865993,-7.10171439e-16 278,3.13400675 278,7 L278,226 C278,229.865993 274.865993,233 271,233 L7,233 C3.13400675,233 3.13798288e-15,229.865993 0,226 L0,7 C-4.73447626e-16,3.13400675 3.13400675,-1.78006981e-16 7,0 L271,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "525411012112056117108112120",
                        x1: "278px",
                        y1: "0px",
                        x2: "17.003832px",
                        y2: "238.703516px",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#329CCA",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "#0687D4",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1029712253106535651119111",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M29.4123223,0 C32.3831005,0 34.8000014,2.41690088 34.8000014,5.38767912 L34.8000014,29.4123223 C34.8000014,32.3831005 32.3831005,34.8000014 29.4123902,34.8000014 L5.38767912,34.8000014 C2.41690088,34.8000014 0,32.3831005 0,29.4123902 L0,5.38767912 C0,2.41690088 2.41690088,0 5.38767912,0 Z M22.8602025,26.4116378 C19.8118039,28.9462605 14.9883334,28.9463285 11.9398669,26.4116378 C9.22594255,28.6597722 5.04450489,28.9485035 2.03906258,27.1166776 L2.03906258,29.4123223 C2.03906258,31.2587614 3.54123998,32.7609388 5.38767912,32.7609388 L29.4123223,32.7609388 C31.2587614,32.7609388 32.7609388,31.2587614 32.7609388,29.4123902 L32.7609388,27.1167456 C29.7557004,28.9485035 25.5739229,28.6597722 22.8602025,26.4116378 Z M22.8602025,18.767464 C19.8118039,21.3020868 14.9883334,21.3021548 11.9398669,18.767464 C9.22594255,21.0155985 5.04450489,21.3043298 2.03906258,19.4725039 L2.03906258,24.6038729 C4.56729628,26.9345214 8.83219957,26.8100706 11.2189223,24.3232978 C11.5984598,23.9283314 12.2812739,23.9283994 12.6608114,24.3232299 C15.1530897,26.9213354 19.6468437,26.9213354 22.1392579,24.3232978 C22.330454,24.1320338 22.5898228,24.0246431 22.8602025,24.0246431 C23.1305822,24.0246431 23.3899509,24.1321017 23.581147,24.3232299 C25.9682096,26.8100706 30.2322973,26.9345894 32.7609388,24.6038729 L32.7609388,19.4725039 C29.7557004,21.3042618 25.5739229,21.0155985 22.8602025,18.767464 Z M32.7609388,10.7752903 L23.8796658,10.7752903 L23.8796658,16.9596311 C26.2967026,19.1868992 30.343902,19.1869672 32.7609388,16.9596311 L32.7609388,10.7752903 Z M21.8406712,15.1434381 L12.9593982,15.1434381 L12.9593982,16.9596991 C15.376435,19.1869672 19.4235664,19.1870351 21.8406712,16.9596991 L21.8406712,15.1434381 Z M10.9203356,10.7752903 L2.03906258,10.7752903 L2.03906258,16.9596311 C4.4560994,19.1868312 8.50329878,19.1869672 10.9203356,16.9596311 L10.9203356,10.7752903 Z M21.8406032,10.7752903 L12.9593982,10.7752903 L12.9593982,13.1043755 L21.8406032,13.1043755 L21.8406032,10.7752903 Z M14.1238388,6.40721041 C13.481738,6.40721041 12.9593302,6.92961824 12.9593302,7.57171905 L12.9593302,8.73622769 L15.2883475,8.73622769 L15.2883475,7.57171905 C15.2883475,6.92961824 14.7659396,6.40721041 14.1238388,6.40721041 Z M25.0441744,6.40721041 C24.4020736,6.40721041 23.8796658,6.92961824 23.8796658,7.57171905 L23.8796658,8.73622769 L26.208751,8.73622769 L26.208751,7.57171905 C26.208751,6.92961824 25.6862752,6.40721041 25.0441744,6.40721041 Z M29.4123902,2.03906258 L5.38767912,2.03906258 C3.54123998,2.03906258 2.03906258,3.54123998 2.03906258,5.38767912 L2.03906258,8.73622769 L10.9204036,8.73622769 L10.9204036,7.57171905 C10.9204036,5.80527914 12.3575349,4.36814783 14.1239748,4.36814783 C15.8904147,4.36814783 17.327546,5.80527914 17.327546,7.57171905 L17.327546,8.73622769 L21.8406712,8.73622769 L21.8406712,7.57171905 C21.8406712,5.80527914 23.2778025,4.36814783 25.0442424,4.36814783 C26.8106823,4.36814783 28.2478136,5.80527914 28.2478136,7.57171905 L28.2478136,8.73629566 L32.7609388,8.73629566 L32.7609388,5.38767912 C32.7609388,3.54123998 31.2587614,2.03906258 29.4123902,2.03906258 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-1407.0 -2402.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#110111110551154911310611952)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(0.0 2011.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#455356571161135712011399)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 1920,0 1920,435 0,435 0,0",
                                    stroke: "none",
                                    fill: "transparent"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(1376.0 2360.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#9810411012112099561095397)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 278,0 278,233 0,233 0,0",
                                    stroke: "none",
                                    fill: "transparent"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(1407.0 2402.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#1029712253106535651119111)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 34.8000014,0 34.8000014,34.8000014 0,34.8000014 0,0",
                                    stroke: "none",
                                    fill: "#FFFFFF"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var CalendarIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "20px",
        height: "20px",
        viewBox: "0 0 20.0 20.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "12111711511495990111108109",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1101031044897105105100120100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1916,0 C1918.76142,-5.07265313e-16 1921,2.23857625 1921,5 L1921,430 C1921,432.761424 1918.76142,435 1916,435 L5,435 C2.23857625,435 2.69835295e-14,432.761424 0,430 L0,5 C-3.38176876e-16,2.23857625 2.23857625,-5.70998362e-15 5,0 L1916,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "5111211451559751101101109",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M176,0 C177.656854,-3.04359188e-16 179,1.34314575 179,3 L179,55 L0,55 L0,3 C-2.02906125e-16,1.34314575 1.34314575,1.19253761e-15 3,0 L176,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "10511911910511354575152100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M203,0 C204.656854,-3.04359188e-16 206,1.34314575 206,3 L206,55 L0,55 L0,3 C-2.02906125e-16,1.34314575 1.34314575,1.63662682e-15 3,0 L203,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "98101521191200120120106104",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M12.9,0 C13.39704,0 13.8,0.40296 13.8,0.9 L13.8,1.8 L18.9,1.8 C19.39704,1.8 19.8,2.20296 19.8,2.7 L19.8,18.9 C19.8,19.39704 19.39704,19.8 18.9,19.8 L0.9,19.8 C0.40296,19.8 0,19.39704 0,18.9 L0,2.7 C0,2.20296 0.40296,1.8 0.9,1.8 L6,1.8 L6,0.9 C6,0.40296 6.40296,0 6.9,0 C7.39704,0 7.8,0.40296 7.8,0.9 L7.8,1.8 L12,1.8 L12,0.9 C12,0.40296 12.40296,0 12.9,0 Z M18,7.2 L1.8,7.2 L1.8,18 L18,18 L18,7.2 Z M18,3.6 L1.8,3.6 L1.8,5.4 L18,5.4 L18,3.6 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-304.0 -1995.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#12111711511495990111108109)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(0.0 2011.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#1101031044897105105100120100)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 1920,0 1920,435 0,435 0,0",
                                    stroke: "none",
                                    fill: "#EFF5F7"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            transform: "translate(270.0 1978.0)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    clipPath: "url(#5111211451559751101101109)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 179,0 179,55 0,55 0,0",
                                        stroke: "none",
                                        fill: "transparent"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    transform: "translate(38.0 18.0)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("text", {
                                        transform: "translate(0.0 14.0)",
                                        fontFamily: "Manrope-Bold, Manrope",
                                        fontSize: "13.0",
                                        fontWeight: "bold",
                                        fill: "#FFFFFF"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            transform: "translate(270.0 1978.0)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    clipPath: "url(#10511911910511354575152100)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 206,0 206,55 0,55 0,0",
                                        stroke: "none",
                                        fill: "transparent"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    transform: "translate(34.0 17.0)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                        clipPath: "url(#98101521191200120120106104)",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                            points: "0,0 19.8,0 19.8,19.8 0,19.8 0,0",
                                            stroke: "none",
                                            fill: "#FFFFFF"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var DatepickerArrowsIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "20px",
        height: "20px",
        viewBox: "0 0 20.0 20.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1175411652951179812112154",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "10410810345095116118115102",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M2388,0 C2391.86599,-7.10171439e-16 2395,3.13400675 2395,7 L2395,736 C2395,739.865993 2391.86599,743 2388,743 L7,743 C3.13400675,743 -5.63699712e-14,739.865993 0,736 L0,7 C-4.73447626e-16,3.13400675 3.13400675,-5.5070775e-15 7,0 L2388,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1071185611649106104104117120",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 L370,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "9511010910711212211510411948",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M12.9,0 C13.39704,0 13.8,0.40296 13.8,0.9 L13.8,1.8 L18.9,1.8 C19.39704,1.8 19.8,2.20296 19.8,2.7 L19.8,18.9 C19.8,19.39704 19.39704,19.8 18.9,19.8 L0.9,19.8 C0.40296,19.8 0,19.39704 0,18.9 L0,2.7 C0,2.20296 0.40296,1.8 0.9,1.8 L6,1.8 L6,0.9 C6,0.40296 6.40296,0 6.9,0 C7.39704,0 7.8,0.40296 7.8,0.9 L7.8,1.8 L12,1.8 L12,0.9 C12,0.40296 12.40296,0 12.9,0 Z M18,7.2 L1.8,7.2 L1.8,18 L18,18 L18,7.2 Z M18,3.6 L1.8,3.6 L1.8,5.4 L18,5.4 L18,3.6 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-594.0 -3198.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#1175411652951179812112154)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(-233.0 2999.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#10410810345095116118115102)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "233,0 2153,0 2153,743 233,743 233,0",
                                    stroke: "none",
                                    fill: "#EFF5F7"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(270.0 3076.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                clipPath: "url(#1071185611649106104104117120)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 374,0 374,609 0,609 0,0",
                                        stroke: "none",
                                        fill: "#FFFFFF"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M4,0 L370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 Z",
                                        stroke: "#F9F9F9",
                                        strokeWidth: "6",
                                        fill: "none",
                                        strokeMiterlimit: "5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(594.0 3198.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#9511010910711212211510411948)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 19.8,0 19.8,19.8 0,19.8 0,0",
                                    stroke: "none",
                                    fill: "#939495"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var ArrowDownIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "11px",
        height: "7px",
        viewBox: "0 0 11.0 7.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "551181145550105570109114",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "111114112108119111984810754",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M2388,0 C2391.86599,-7.10171439e-16 2395,3.13400675 2395,7 L2395,736 C2395,739.865993 2391.86599,743 2388,743 L7,743 C3.13400675,743 -5.63699712e-14,739.865993 0,736 L0,7 C-4.73447626e-16,3.13400675 3.13400675,-5.5070775e-15 7,0 L2388,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "4857551005510811710849112",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 L370,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "12210454122519510911510156",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M9.03252,0 L10.24,1.20744 L5.12,6.32744 L0,1.20744 L1.20748,0 L5.12,3.91252 L9.03252,0 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-601.0 -3295.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#551181145550105570109114)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(-233.0 2999.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#111114112108119111984810754)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "233,0 2153,0 2153,743 233,743 233,0",
                                    stroke: "none",
                                    fill: "#EFF5F7"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(270.0 3076.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                clipPath: "url(#4857551005510811710849112)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 374,0 374,609 0,609 0,0",
                                        stroke: "none",
                                        fill: "#FFFFFF"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M4,0 L370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 Z",
                                        stroke: "#F9F9F9",
                                        strokeWidth: "6",
                                        fill: "none",
                                        strokeMiterlimit: "5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(601.0 3295.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                transform: "translate(0.0 0.036279999999999646)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                    clipPath: "url(#12210454122519510911510156)",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 10.24,0 10.24,6.32744 0,6.32744 0,0",
                                        stroke: "none",
                                        fill: "#939495"
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var DatepickerMiddleIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "27px",
        height: "21px",
        viewBox: "0 0 27 21",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Apple-TV-Copy-6",
                transform: "translate(-408.000000, -2155.000000)",
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    id: "Group-5-Copy",
                    transform: "translate(408.000000, 2155.000000)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            id: "enter-arrow",
                            transform: "translate(0.000000, 9.100000)",
                            fill: "#22B645",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                id: "Path",
                                points: "15.1725 0.90125 15.1725 4.47125 3.3915 4.47125 6.6045 1.25825 5.355 0.00875 0 5.36375 5.355 10.71875 6.6045 9.46925 3.3915 6.25625 16.9575 6.25625 16.9575 0.90125"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            id: "enter-arrow",
                            transform: "translate(18.100000, 5.700000) scale(-1, -1) translate(-18.100000, -5.700000) translate(9.600000, 0.200000)",
                            fill: "#FF4300",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                id: "Path",
                                points: "15.1725 0.90125 15.1725 4.47125 3.3915 4.47125 6.6045 1.25825 5.355 0.00875 0 5.36375 5.355 10.71875 6.6045 9.46925 3.3915 6.25625 16.9575 6.25625 16.9575 0.90125"
                            })
                        })
                    ]
                })
            })
        })
    });
};
var PlusIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "14px",
        height: "13px",
        viewBox: "0 0 14.0 13.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "10910611549511201111115599",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "122525710311012154107104101",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 L370,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "5248951101035511012210250",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M344,0 C345.104569,-2.02906125e-16 346,0.8954305 346,2 L346,261 C346,262.104569 345.104569,263 344,263 L2,263 C0.8954305,263 -7.52907669e-16,262.104569 0,261 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.86744138e-15 2,0 L344,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "104116569711497115975449",
                        x: "-44.3983402%",
                        y: "-39.8034398%",
                        filterUnits: "userSpaceOnUse",
                        width: "166.390041%",
                        height: "178.624079%",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "27",
                                in: "SourceAlpha",
                                result: "5011957511051005710248114"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dx: "0",
                                dy: "52",
                                in: "5011957511051005710248114",
                                result: "1141041115711011310253112117"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                values: "0 0 0 0.3584116865948933 0 0 0 0 0.4373876045369541 0 0 0 0 0.4765625 0 0 0 0 0.1622869318181818 0",
                                type: "matrix",
                                in: "1141041115711011310253112117"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1075354491125211110110553",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M374,0 L374,299 L0,299 L0,0 L374,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "955410310848991054551112",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "5411952981225210411612145",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M7.5,0 L7.5,5.499 L13,5.5 L13,7.5 L7.5,7.499 L7.5,13 L5.5,13 L5.5,7.499 L0,7.5 L0,5.5 L5.5,5.499 L5.5,0 L7.5,0 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-509.0 -821.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#10910611549511201111115599)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(270.0 554.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                clipPath: "url(#122525710311012154107104101)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 374,0 374,609 0,609 0,0",
                                        stroke: "none",
                                        fill: "#FFFFFF"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M4,0 L370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 Z",
                                        stroke: "#F9F9F9",
                                        strokeWidth: "6",
                                        fill: "none",
                                        strokeMiterlimit: "5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(284.0 815.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#5248951101035511012210250)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 346,0 346,263 0,263 0,0",
                                    stroke: "none",
                                    fill: "#F9F9F9"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            transform: "translate(270.0 728.0)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 374,0 374,299 0,299 0,0 0,0",
                                    stroke: "none",
                                    fill: "#000000",
                                    filter: "url(#104116569711497115975449)"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                    clipPath: "url(#1075354491125211110110553)",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                            points: "0,0 374,0 374,299 0,299 0,0",
                                            stroke: "none",
                                            fill: "#FFFFFF"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                            points: "0,0 374,0 374,299 0,299 0,0 0,0",
                                            stroke: "#F9F9F9",
                                            strokeWidth: "6",
                                            fill: "none",
                                            strokeMiterlimit: "5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                    transform: "translate(229.0 83.0)",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                            clipPath: "url(#955410310848991054551112)",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                points: "0,0 34,0 34,34 0,34 0,0 0,0",
                                                stroke: "#9B9B9C",
                                                strokeWidth: "2",
                                                fill: "none",
                                                strokeMiterlimit: "5",
                                                opacity: "34.9795387%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                            transform: "translate(10.5 10.0)",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                                clipPath: "url(#5411952981225210411612145)",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                    points: "0,0 13,0 13,13 0,13 0,0",
                                                    stroke: "none",
                                                    fill: "#9B9B9C"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var MinusIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "14px",
        height: "3px",
        viewBox: "0 0 14.0 3.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1164850509912210111551100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "571185453121971145050117",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 L370,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "11110655994511811410812050",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M344,0 C345.104569,-2.02906125e-16 346,0.8954305 346,2 L346,261 C346,262.104569 345.104569,263 344,263 L2,263 C0.8954305,263 -7.52907669e-16,262.104569 0,261 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.86744138e-15 2,0 L344,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "11601181031095748103113100",
                        x: "-44.3983402%",
                        y: "-39.8034398%",
                        filterUnits: "userSpaceOnUse",
                        width: "166.390041%",
                        height: "178.624079%",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "27",
                                in: "SourceAlpha",
                                result: "1125010610910712054106102109"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feOffset", {
                                dx: "0",
                                dy: "52",
                                in: "1125010610910712054106102109",
                                result: "5099105005352122103112"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feColorMatrix", {
                                values: "0 0 0 0.3584116865948933 0 0 0 0 0.4373876045369541 0 0 0 0 0.4765625 0 0 0 0 0.1622869318181818 0",
                                type: "matrix",
                                in: "5099105005352122103112"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1219511510011498107489948",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M374,0 L374,299 L0,299 L0,0 L374,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "1221035355951081155210698",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M34,0 L34,34 L0,34 L0,0 L34,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "118571175312253971029899",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M2,0 L2,13 L0,13 L0,0 L2,0 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-591.0 -826.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    clipPath: "url(#1164850509912210111551100)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(270.0 554.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                clipPath: "url(#571185453121971145050117)",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                        points: "0,0 374,0 374,609 0,609 0,0",
                                        stroke: "none",
                                        fill: "#FFFFFF"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M4,0 L370,0 C372.209139,-4.05812251e-16 374,1.790861 374,4 L374,605 C374,607.209139 372.209139,609 370,609 L4,609 C1.790861,609 -5.05852902e-15,607.209139 0,605 L0,4 C-7.1463071e-16,1.790861 1.790861,-4.92325827e-15 4,0 Z",
                                        stroke: "#F9F9F9",
                                        strokeWidth: "6",
                                        fill: "none",
                                        strokeMiterlimit: "5"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(284.0 815.0)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#11110655994511811410812050)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 346,0 346,263 0,263 0,0",
                                    stroke: "none",
                                    fill: "#F9F9F9"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                            transform: "translate(270.0 728.0)",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 374,0 374,299 0,299 0,0 0,0",
                                    stroke: "none",
                                    fill: "#000000",
                                    filter: "url(#11601181031095748103113100)"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                    clipPath: "url(#1219511510011498107489948)",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                            points: "0,0 374,0 374,299 0,299 0,0",
                                            stroke: "none",
                                            fill: "#FFFFFF"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                            points: "0,0 374,0 374,299 0,299 0,0 0,0",
                                            stroke: "#F9F9F9",
                                            strokeWidth: "6",
                                            fill: "none",
                                            strokeMiterlimit: "5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                                    transform: "translate(311.0 83.0)",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                            clipPath: "url(#1221035355951081155210698)",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                points: "0,0 34,0 34,34 0,34 0,0 0,0",
                                                stroke: "#9B9B9C",
                                                strokeWidth: "2",
                                                fill: "none",
                                                strokeMiterlimit: "5",
                                                opacity: "34.9795387%"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                            transform: "translate(23.5 15.49999999999966) rotate(90.00000000000001)",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                                clipPath: "url(#118571175312253971029899)",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                    points: "0,0 2,0 2,13 0,13 0,0",
                                                    stroke: "none",
                                                    fill: "#9B9B9C"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var DetailIncludedPriceIcon = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        version: "1.1",
        width: "10px",
        height: "11px",
        viewBox: "0 0 10.0 11.0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "i0x",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1920,0 L1920,6209 L0,6209 L0,0 L1920,0 Z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "i1x",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M4.31927628,0 C4.34597969,0.0200275562 4.37490838,0.0400551123 4.40161179,0.0623079525 C5.81021657,1.15047184 7.21659607,2.23641044 8.62075028,3.32457432 L8.62075028,9.18819771 C7.3234097,9.70891417 5.90590378,9.99375052 4.42163934,9.99375052 C2.85281411,9.99375052 1.35742325,9.67330962 0,9.09473578 L0,3.33570074 C1.4063795,2.24976214 2.812759,1.16382354 4.2191385,0.0778849406 C4.25029247,0.0534068164 4.28589702,0.0267034082 4.31927628,0 Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                transform: "translate(-1284.0 -1410.0)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    clipPath: "url(#i0x)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        transform: "translate(1284.0 1410.0)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                            transform: "translate(0.5350288453228131 0.1762341304522579)",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                                clipPath: "url(#i1x)",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                    points: "0,0 8.62075028,0 8.62075028,9.99375052 0,9.99375052 0,0",
                                    stroke: "none",
                                    fill: "#ED7722"
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
var PlayButtonBigIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "41px",
        height: "41px",
        viewBox: "0 0 41 41",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                id: "Apple-TV-Copy-6",
                transform: "translate(-1438.000000, -1108.000000)",
                fill: "#FFFFFF",
                fillRule: "nonzero",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Group-7",
                    transform: "translate(1404.000000, 1108.000000)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        id: "play-button",
                        transform: "translate(34.000000, 0.000000)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M20.0704,0 C9.0029072,0 0,9.0037696 0,20.0704 C0,31.1370304 9.0029072,40.1408 20.0704,40.1408 C31.1378928,40.1408 40.1408,31.1370304 40.1408,20.0704 C40.1408,9.0037696 31.1378928,0 20.0704,0 Z M28.0492464,20.7735696 L16.3415392,28.2999696 C16.2043392,28.3889536 16.0458928,28.4330928 15.8890928,28.4330928 C15.7518928,28.4330928 15.6130464,28.3987536 15.4889392,28.331016 C15.2194,28.184016 15.0528,27.9030304 15.0528,27.5968 L15.0528,12.544 C15.0528,12.2377696 15.2194,11.956784 15.4889392,11.809784 C15.7535392,11.6644304 16.0850928,11.673368 16.3415392,11.8408304 L28.0492464,19.3672304 C28.2877392,19.5207376 28.4330928,19.7862 28.4330928,20.0704 C28.4330928,20.3546 28.2877392,20.619984 28.0492464,20.7735696 Z",
                            id: "Shape"
                        })
                    })
                })
            })
        })
    });
};
var VillaItemProp1Icon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        fill: "#FC8919",
        width: "19px",
        height: "21px",
        viewBox: "0 0 19 21",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "teamwork-copy-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.07375 4.73281L4.07375 0.820469C4.07375 0.538125 4.11422 0.262813 4.19 0L1.55187 0C1.12406 0 0.736094 0.174063 0.455156 0.455C0.174219 0.735937 0 1.12406 0 1.55172L0 4.66484C0 5.04375 0.138281 5.39266 0.367344 5.66406C0.486406 5.80531 0.630469 5.925 0.792656 6.01656L0.792656 10.5414C0.792656 10.8722 1.06078 11.1403 1.39141 11.1403L5.06984 11.1403L5.06984 6.95734C4.44094 6.38953 4.07375 5.58063 4.07375 4.73281Z",
                    transform: "translate(0 7.7628174)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.34594 4.69187C3.63953 4.69187 4.69187 3.63953 4.69187 2.34594C4.69187 1.05234 3.63953 0 2.34594 0C1.05234 0 0 1.05234 0 2.34594C0 3.63953 1.05234 4.69187 2.34594 4.69187Z",
                    transform: "translate(0.88793945 2.362671)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M6.02625 0L1.79641 0C1.30141 0 0.852188 0.201719 0.526875 0.526875C0.201563 0.852188 0 1.30141 0 1.79656L0 5.70891C0 6.14766 0.16 6.55172 0.424844 6.86562C0.581875 7.05172 0.77625 7.20563 0.996094 7.31563L0.996094 13.0944C0.996094 13.4252 1.26422 13.6933 1.595 13.6933L6.22781 13.6933C6.55859 13.6933 6.82672 13.4252 6.82672 13.0944L6.82672 7.31563C7.04656 7.20563 7.24094 7.05172 7.39781 6.86562C7.66281 6.55172 7.82281 6.14781 7.82281 5.70891L7.82281 1.79656C7.82281 1.30141 7.62125 0.852188 7.29594 0.527031C6.97062 0.201719 6.52141 0 6.02625 0Z",
                    fill: "#FC8919",
                    transform: "translate(5.2713623 6.786743)",
                    id: "Path",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.79453 5.58906C4.33547 5.58906 5.58906 4.33547 5.58906 2.79453C5.58906 1.25359 4.33547 0 2.79453 0C1.25359 0 0 1.25359 0 2.79453C0 4.33547 1.25359 5.58906 2.79453 5.58906L2.79453 5.58906Z",
                    transform: "translate(6.387329 0)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.695 0.455C4.41406 0.174063 4.02609 0 3.59828 0L0.879844 0C0.955469 0.262813 0.996094 0.538125 0.996094 0.820469L0.996094 4.73281C0.996094 5.58047 0.628906 6.38953 0 6.95734L0 11.1359C0.0235938 11.1388 0.0478125 11.1403 0.0723438 11.1403L3.75859 11.1403C4.08938 11.1403 4.3575 10.8722 4.3575 10.5414L4.3575 6.01656C4.51953 5.92516 4.66359 5.80531 4.78281 5.66406C5.01188 5.39266 5.15016 5.04375 5.15016 4.66484L5.15016 1.55172C5.15016 1.12406 4.97594 0.735937 4.695 0.455L4.695 0.455Z",
                    transform: "translate(13.295776 7.7628174)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M2.34594 4.69187C3.63953 4.69187 4.69187 3.63953 4.69187 2.34594C4.69187 1.05234 3.63953 0 2.34594 0C1.0525 0 0 1.05234 0 2.34594C0 3.63953 1.0525 4.69187 2.34594 4.69187Z",
                    transform: "translate(12.864502 2.362671)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                })
            ]
        })
    });
};
var VillaItemProp2Icon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "bed-2-copy-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.00715 6.94741C1.00715 5.24011 2.39616 3.8511 4.10346 3.8511L8.00897 3.8511C9.00144 3.8511 9.88574 4.32103 10.4527 5.04949C11.0197 4.32103 11.904 3.8511 12.8966 3.8511L16.802 3.8511C18.5093 3.8511 19.8983 5.24007 19.8983 6.94741L19.8983 8.94073C20.2514 9.00279 20.5891 9.10976 20.9055 9.25537L20.9055 3.33482C20.9055 1.49305 19.4125 0 17.5707 0L3.33482 0C1.49306 0 0 1.49305 0 3.33482L0 9.25533C0.316395 9.10971 0.65412 9.00274 1.00715 8.94069L1.00715 6.94741Z",
                    transform: "translate(1.0672607 0)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.74632 0C0.781875 0 0 0.78183 0 1.74632L0 3.67695L7.39809 3.67695L7.39809 1.74632C7.39809 0.781875 6.61626 6.39488e-16 5.65177 6.39488e-16L1.74632 0Z",
                    transform: "translate(3.4244385 5.201172)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.74632 0C0.781875 0 0 0.78183 0 1.74632L0 3.67695L7.39809 3.67695L7.39809 1.74632C7.39809 0.781875 6.61621 6.39488e-16 5.65177 6.39488e-16L1.74632 0Z",
                    transform: "translate(12.217529 5.201172)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M0.003105 5.03554C0.003105 5.40833 0.305325 5.71055 0.678105 5.71055L2.2311 5.71055C2.60388 5.71055 2.9061 5.40833 2.9061 5.03554L2.9061 3.08466C3.16364 3.13182 3.46572 3.16125 3.8417 3.16125C5.76099 3.16125 5.76099 2.3967 7.68029 2.3967C9.59958 2.3967 9.59958 3.16125 11.5188 3.16125C13.4382 3.16125 13.4382 2.3967 15.3575 2.3967C17.2769 2.3967 17.2769 3.16125 19.1964 3.16125C19.5724 3.16125 19.8747 3.13182 20.1322 3.08462L20.1322 5.03554C20.1322 5.40833 20.4345 5.71055 20.8072 5.71055L22.3602 5.71055C22.733 5.71055 23.0352 5.40833 23.0352 5.03554L23.0352 0L0 0L0.003105 5.03554Z",
                    transform: "translate(0.0008544922 17.321533)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M20.2461 0L2.79387 0C1.25087 0 0 1.25086 0 2.79387L0 5.74916L23.04 5.74916L23.04 2.79387C23.04 1.25086 21.7891 0 20.2461 0Z",
                    transform: "translate(0 10.228149)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                })
            ]
        })
    });
};
var VillaItemProp3Icon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "31px",
        height: "24px",
        viewBox: "0 0 31 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "shower-2-copy-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M25.4125 2.74752L24.9062 2.24004C24.3746 1.71042 23.5909 1.61184 22.948 1.91358C20.3138 -0.38046 16.445 -0.61026 13.5587 1.40004C12.135 0.48378 10.4925 0 8.7975 0C3.94626 0 0 3.94626 0 8.7975L0 22.4C0 22.7538 0.28626 23.04 0.64002 23.04L3.20004 23.04C3.55374 23.04 3.84 22.7538 3.84 22.4L3.84 8.7975C3.84 6.06378 6.06378 3.84 8.7975 3.84C9.57252 3.84 10.33 4.0206 11.0175 4.36686C9.68892 7.12686 10.1422 10.4063 12.1485 12.7105C12.0419 12.9379 11.9737 13.1815 11.9737 13.44C11.9737 13.9031 12.1537 14.3387 12.4812 14.6656L12.9875 15.1725C13.1075 15.2925 13.27 15.36 13.44 15.36C13.61 15.36 13.7725 15.2925 13.8925 15.1725L25.4125 3.6525C25.6625 3.40254 25.6625 2.99754 25.4125 2.74752Z",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.24775 0.437027C1.13525 0.101387 0.775254 -0.0779534 0.437754 0.0326266C0.102774 0.143867 -0.0784856 0.506387 0.0327544 0.842027L1.31273 4.68203C1.40273 4.95017 1.65275 5.11955 1.92023 5.11955C1.98773 5.11955 2.05523 5.10893 2.12273 5.08643C2.45771 4.97519 2.63897 4.61267 2.52773 4.27703L1.24775 0.437027Z",
                    transform: "translate(17.919678 12.800415)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M3.19999 3.84001C3.36373 3.84001 3.52747 3.77749 3.65251 3.65251C3.90253 3.40249 3.90253 2.99749 3.65251 2.74753L1.09249 0.187515C0.842475 -0.062505 0.437475 -0.062505 0.187515 0.187515C-0.062505 0.437535 -0.062505 0.842535 0.187515 1.09249L2.74753 3.65251C2.87245 3.77749 3.03625 3.84001 3.19999 3.84001Z",
                    transform: "translate(20.47998 10.23999)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M0.0327544 0.436963C-0.0784856 0.772603 0.102774 1.13506 0.437754 1.24636L4.27775 2.52634C4.34525 2.54884 4.41275 2.55946 4.48025 2.55946C4.74773 2.55946 4.99775 2.39008 5.08775 2.12194C5.19899 1.7863 5.01773 1.42384 4.68275 1.31254L0.842754 0.0325633C0.510234 -0.0780166 0.146514 0.101983 0.0327544 0.436963Z",
                    transform: "translate(23.039795 7.680542)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M1.17256 0.285197C0.975041 -0.0091631 0.576281 -0.0885431 0.285041 0.107717C-0.00871892 0.303977 -0.0886989 0.700817 0.107561 0.995237L2.66758 4.83524C2.79136 5.02022 2.99386 5.12024 3.20008 5.12024C3.3226 5.12024 3.44632 5.08526 3.5551 5.01272C3.84886 4.81646 3.92884 4.41962 3.73258 4.1252L1.17256 0.285197Z",
                    transform: "translate(21.759888 15.359863)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M4.83508 2.66707L0.995081 0.107054C0.703841 -0.0873458 0.305081 -0.0104258 0.107561 0.284534C-0.0886989 0.578894 -0.00871892 0.975794 0.285041 1.17205L4.12504 3.73207C4.23382 3.80455 4.35754 3.83959 4.48006 3.83959C4.68634 3.83959 4.88884 3.73957 5.01256 3.55459C5.20882 3.26017 5.12884 2.86333 4.83508 2.66707Z",
                    transform: "translate(25.599976 11.520508)",
                    id: "Path",
                    fill: "#FC8919",
                    stroke: "none"
                })
            ]
        })
    });
};
var Icon = function(param) {
    var name = param.name, size = param.size;
    var icons = {
        playbutton: PlayButtonIcon,
        heart: HeartIcon,
        DetailPool: DetailPoolIcon,
        Calendar: CalendarIcon,
        DatepickerArrows: DatepickerArrowsIcon,
        ArrowDown: ArrowDownIcon,
        Plus: PlusIcon,
        Minus: MinusIcon,
        DetailIncludedPrice: DetailIncludedPriceIcon,
        PlayButtonBig: PlayButtonBigIcon,
        DatepickerMiddle: DatepickerMiddleIcon,
        VillaItemProp1: VillaItemProp1Icon,
        VillaItemProp2: VillaItemProp2Icon,
        VillaItemProp3: VillaItemProp3Icon,
        ktb: _icons_Ktb__WEBPACK_IMPORTED_MODULE_2__["default"]
    };
    var Component = icons[name];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

}]);